import { apiContract } from "@homesite/api-contract";
import { initClient } from "@ts-rest/core";

export interface ApiClientOptions {
	baseUrl: string;
	baseHeaders?: Record<string, string>;
	/**
	 * Fetch credentials mode. Accepts the same values as the native Fetch API
	 * `credentials` option: "omit" | "same-origin" | "include".
	 */
	credentials?: "omit" | "same-origin" | "include";
}

export function createApiClient(opts: ApiClientOptions) {
	return initClient(apiContract, {
		baseUrl: opts.baseUrl,
		baseHeaders: opts.baseHeaders ?? {},
		credentials: opts.credentials,
	});
}

export type ApiClient = ReturnType<typeof createApiClient>;

export type PublicVerificationClient = ApiClient["publicVerification"];
